import React, { useState } from "react";
import { useFormContext } from "react-hook-form";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import IbanInfoPreview from "./IbanInfoPreview";

import { ReactComponent as LaptopIcon } from "assets/images/previewTabs/laptop-icon.svg";
import { ReactComponent as PhoneIcon } from "assets/images/previewTabs/phone-icon.svg";

import { FormValues } from "../validation";
import { IbanInvoiceResponseDto } from "api";

import { styles } from "./styles";

export enum TabsEnum {
  DESKTOP = "desktop",
  MOBILE = "mobile",
}

const Preview: React.FC = () => {
  const formContext = useFormContext<FormValues>();

  const [activeTab, setActiveTab] = useState(TabsEnum.MOBILE);

  const iban = {
    ibanQrInvoiceUid: "",
    bank: formContext.watch("bankName"),
    organizationName: formContext.watch("organizationName"),
    identificationCode: formContext.watch("identificationCode"),
    iban: formContext.watch("iban"),
    amount: formContext.watch("amount"),
    publicName: formContext.watch("publicName"),
    paymentPurpose: formContext.watch("paymentPurpose"),
    ibanInvoiceUrl: "",
    ibanPaymentUrl: `${window.location.origin}/`,
    invoiceDateTimeUtc: "",
    invoiceNumber: 0,
    clientNotes: formContext.watch("showClientNotes")
      ? formContext.watch("clientNotes")
      : "",
    paymentPurposeOptions: {
      requestPayerFullName: formContext.watch("requestPayerFullName"),
      requestOrderNumber: formContext.watch("requestOrderNumber"),
    },
    amountType: formContext.watch("amountType"),
  } as IbanInvoiceResponseDto;

  const handleTabChange = (e: React.SyntheticEvent, newValue: TabsEnum) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={styles.preview}>
      <Box sx={styles.previewHeader}>
        <Typography variant="subtitle1">Як побачить платник</Typography>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab
            data-testid="desktop-tab"
            value={TabsEnum.DESKTOP}
            label={<LaptopIcon />}
          />
          <Tab
            data-testid="mobile-tab"
            value={TabsEnum.MOBILE}
            label={<PhoneIcon />}
          />
        </Tabs>
      </Box>

      <Stack direction="column" gap={1} sx={{ pt: 2, pb: 2 }}>
        <IbanInfoPreview iban={iban} isMobile={activeTab === TabsEnum.MOBILE} />
      </Stack>
    </Box>
  );
};

export default Preview;
